import * as styles from './styles/pills.module.scss';

import type { IScrollAccordionPillsProps } from '../types';
import { generateClassName } from '@klv/shared/utils/functions';

export const Pills = ({
  removePills = false,
  pills,
}: IScrollAccordionPillsProps) => {
  return (
    <div className={styles.pillContainer}>
      {Object.keys(pills).map((pill, i) => (
        <div key={`${i}-${pill}`} className={generateClassName([styles.pill, styles[pill as keyof typeof styles],  removePills ? styles.removePills : ''])}>
          {pills[pill as keyof typeof pills]}
        </div>
      ))}
  </div>
  );
};


